import { render, staticRenderFns } from "./guowai.vue?vue&type=template&id=86aad008&"
import script from "./guowai.vue?vue&type=script&lang=js&"
export * from "./guowai.vue?vue&type=script&lang=js&"
import style0 from "./guowai.vue?vue&type=style&index=0&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports